import script from "./CommunityIcons.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommunityIcons.vue?vue&type=script&lang=ts&setup=true"

import "./CommunityIcons.vue?vue&type=style&index=0&id=101838ba&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/curl-fe-build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-101838ba"]])

export default __exports__